import * as yup from "yup";

const BlockedUserSchema = yup.object().shape({
  email: yup
    .string()
    .email("Email duhet të jetë i vlefshëm.")
    .max(255, "Email nuk duhet të kalojë 255 karaktere.")
    .required("Email është i detyrueshëm."),
  blockEsimReservationNlb: yup.boolean().default(false),
  blockEsimReservationStripe: yup.boolean().default(false),
  blockJourneyReservationNlb: yup.boolean().default(false),
  blockJourneyReservationStripe: yup.boolean().default(false),
  blockAll: yup.boolean().default(false),
  blockReason: yup.string().max(500, "Arsyeja nuk duhet të kalojë 500 karaktere.")
});

export default BlockedUserSchema;
